import React, { useEffect } from "react";
import { connect } from "react-redux";
import { debug } from "../../utils";
import * as validationService from "../add-device-modal/validationService";

function ApiMonitorUriField({ value, onChange, error, disabled }) {

    useEffect(() => {
        validationService.validateMonitorUri(value, 'apiMonitorUri');
        return () => validationService.cleanValidation('apiMonitorUri');
    }, [value])

    return (
        <div className="form-group">
            <div className="oct_form-group oct_form-sm">
                <label htmlFor="monitoruri">Monitor URI <span className="modal-v2-required-mark">*</span></label>
                <input className={`form-control oct_field ${error && 'border-danger'}`}
                    id="monitoruri"
                    value={value}
                    disabled={disabled}
                    onChange={disabled ? null : (event => onChange(event.target.value))} />
            </div>
        </div>
    )
}

function mapStateToProps(state) {
    debug("ApiMonitorUriField mapStateToProps", state);
    const addDeviceModal = state.addDeviceModal;
    const validation = state.validation;
    const anotherSectionActive = false;//!!addDeviceModal.apiUsername || !!addDeviceModal.apiPassword
    return {
        apiMonitorUri: addDeviceModal.apiMonitorUri || '',
        error: validation.apiMonitorUri,
        anotherSectionActive
    }
}

export default connect(mapStateToProps)(ApiMonitorUriField);
